import React from 'react';
import Header from "../Header.jsx";
import PdfCV from './pdf/KB__CV.pdf';

class Worker extends React.Component{

    render(){
        const header__work = <div className="header"><h2>ABOUT</h2><h3>MY WORK</h3></div>;
        return(
            <React.Fragment>
                <Header />
                {header__work}
                <div className="open--to--work">
                    <span className="green"></span>
                    <a href={PdfCV} target="_blank" rel="noreferrer">DOWNLOAD MY CV</a>
                </div>
            </React.Fragment>
        );
    }

}

export default Worker;